import DashboardService from "@/src/api/DashboardService.js";
import AppStoreService from "@/src/api/AppStoreService.js";

const initialVersion = window.APP_STORE_CONFIG?.version || "v1";
console.log('[appStore] Initializing with window.APP_STORE_CONFIG:', window.APP_STORE_CONFIG);
console.log('[appStore] Initial appStoreVersion:', initialVersion);

export default {
  namespaced: true,
  state: {
    appStoreVersion: initialVersion,
    lastRoute: "/i-assistant",
  },
  mutations: {
    SET_APP_STORE_VERSION(state, version) {
      state.appStoreVersion = version;
    },
    SET_LAST_ROUTE(state, route) {
      state.lastRoute = route;
    },
  },
  actions: {
    async fetchAppStoreVersion({ commit, state }) {
      if (!state.appStoreVersion || state.appStoreVersion === "") {
        const version = window.APP_STORE_CONFIG?.version || "v1";
        commit("SET_APP_STORE_VERSION", version);
      }
    },
    async refreshAppStoreVersion({ commit }) {
      // Force refresh the version (used after toggle)
      try {
        const response =
          await DashboardService.fetchCurrentWorkspaceAppStoreVersion();
        if (response?.success) {
          commit("SET_APP_STORE_VERSION", response.app_store_version);
        }
      } catch (error) {
        console.error(
          "An error occurred while refreshing app store version: ",
          error,
        );
      }
    },
    async toggleAppStoreVersion({ commit }) {
      // Toggle the version and refresh the store
      try {
        const response =
          await AppStoreService.toggleAndRefreshAppStoreVersion();
        if (response?.success && response?.refreshed_version?.success) {
          commit(
            "SET_APP_STORE_VERSION",
            response.refreshed_version.app_store_version,
          );
        }
        return response;
      } catch (error) {
        console.error(
          "An error occurred while toggling app store version: ",
          error,
        );
        throw error;
      }
    },
  },
  getters: {
    isAppStoreV1: (state) => state.appStoreVersion === "v1",
    appStoreVersion: (state) => state.appStoreVersion,
    lastRoute: (state) => state.lastRoute,
  },
};
